import { useQueryClient } from '@tanstack/react-query';
import { pathgen } from 'object-path-generator';
import { useOverlayContext } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { errorTextsPath } from '~/infra/error-response/ErrorResponse';
import { RelationshipErrorResponse } from '~/infra/error-response/RelationshipErrorResponse';
import { useStoreActions } from '~/store/store-context';
import { QueryKeys } from '../queryKeys';
import { useMutationState } from '../useMutationState';
export const useRepublishProposalTestIds = pathgen('useRepublishProposalTestIds');
export const useRepublishRelationship = ()=>{
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    return async (relationshipId)=>{
        await api.relationship.republish(relationshipId);
        queryClient.removeQueries({
            queryKey: [
                QueryKeys.CustomPageText
            ]
        });
    };
};
export const useShowRepublishError = ()=>{
    const { t: editInPlaceTexts } = useLocaleKeys('proposal.studio.editInPlace');
    const { t: errorTexts } = useLocaleKeys(errorTextsPath);
    const { showErrorToast } = useOverlayContext();
    return (error, draft)=>{
        const reason = new RelationshipErrorResponse(error).republishRefusalMessage(errorTexts, draft.legalTermsDocuments);
        showErrorToast(reason !== null && reason !== void 0 ? reason : editInPlaceTexts.republishErrorToast(), useRepublishProposalTestIds.ErrorToast());
    };
};
export const useRepublishProposal = function useRepublishProposal() {
    let { onSuccess } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const republishRelationship = useRepublishRelationship();
    const { t: editInPlaceTexts } = useLocaleKeys('proposal.studio.editInPlace');
    const showRepublishError = useShowRepublishError();
    const { mutate, isLoading } = useMutationState({
        mutationFn: async (param)=>{
            let { draft, relationshipId } = param;
            await api.draft.save(draft);
            await republishRelationship(relationshipId);
        },
        withPageLoader: true,
        mutationName: 'republish-proposal',
        toasts: {
            successMessage: editInPlaceTexts.republishSuccessToast(),
            successTestId: useRepublishProposalTestIds.SuccessToast()
        },
        onSuccess: ()=>onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(),
        onError: (error, param)=>{
            let { draft } = param;
            return showRepublishError(error, draft);
        }
    });
    return {
        republishProposal: mutate,
        isRepublishing: isLoading
    };
};
